export default [{
  path: '/home',
  component: resolve => require(['@/components/base/view/main/main.vue'], resolve),
  children: [{
      path: '/wf/tpl/list',
      component: resolve => require(['@/components/base/view/wf/cfg/list/tpl.vue'], resolve) // 模板列表
  },{
    path: '/wf/tpl/edit/:key',
    component: resolve => require(['@/components/base/view/wf/cfg/edit/edit.vue'], resolve) // 模板编辑
  },{
    path: '/wf/tpl/edit/node/:key/:name',
    component: resolve => require(['@/components/base/view/wf/cfg/edit/node/node.vue'], resolve) // 流程环节编辑
  },{
    path: '/wf/task',
    component: resolve => require(['@/components/base/view/wf/exec/task.vue'], resolve) // 任务中心
  },{
    path: '/wf/test',
    component: resolve => require(['@/components/base/view/wf/exec/test/test.vue'], resolve) // 任务中心
  }]
}]



// WEBPACK FOOTER //
// ./src/components/base/router/wf.js